/* Memorial · oferta de segundo arreglo en el carrito (5%) + copia de datos en la ficha */
(function () {
  'use strict';

  var COLECCION = 'ofertas-carrito';
  var DESCUENTO = 0.05;
  var MAX_TARJETAS = 10;
  var ofertasCache = null;
  var ultimaClave = '';
  var trabajando = false;
  var temporizador = null;

  function dinero(centavos) { return 'S/ ' + (centavos / 100).toFixed(2); }
  function aCentavos(texto) { return Math.round(parseFloat(texto) * 100); }

  function categoria(handle) {
    var reglas = [['cruz', 'cruz'], ['corona-de-corazon', 'corazon'], ['corona', 'corona'], ['lagrima-de-piso', 'piso'], ['lagrima', 'pie'], ['manto', 'manto']];
    for (var i = 0; i < reglas.length; i++) if (handle.indexOf(reglas[i][0]) === 0) return reglas[i][1];
    return 'arreglo';
  }

  function estilos() {
    if (document.getElementById('mm-cart-oferta-css')) return;
    var s = document.createElement('style');
    s.id = 'mm-cart-oferta-css';
    s.textContent =
      '.mm-cart-oferta{margin:16px 20px 8px;padding:16px;border-radius:12px;background:rgba(229,225,209,.45);border:1px solid rgba(23,43,33,.12)}' +
      '.mm-cart-oferta__titulo{margin:0 0 4px;font-size:15px;font-weight:600;line-height:1.3;color:#172B21}' +
      '.mm-cart-oferta__nota{margin:0 0 12px;font-size:13px;line-height:1.4;color:#4a4a4a}' +
      '.mm-cart-oferta__carril{position:relative}' +
      '.mm-cart-oferta__lista{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding:2px}' +
      '.mm-cart-oferta__lista::-webkit-scrollbar{display:none}' +
      '.mm-cart-oferta__card{flex:0 0 132px;scroll-snap-align:start;display:flex;flex-direction:column;gap:6px;padding:8px;border-radius:10px;background:#fff;border:1px solid rgba(23,43,33,.12);text-decoration:none;color:inherit}' +
      '.mm-cart-oferta__card:hover{border-color:#29371C}' +
      '.mm-cart-oferta__img{width:100%;aspect-ratio:4/5;object-fit:cover;border-radius:6px;background:#eee}' +
      '.mm-cart-oferta__nombre{font-size:12px;line-height:1.3;color:#172B21;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:31px}' +
      '.mm-cart-oferta__precio{display:flex;flex-wrap:wrap;align-items:baseline;gap:4px 6px;font-size:13px}' +
      '.mm-cart-oferta__precio b{color:#29371C;font-size:14px}.mm-cart-oferta__precio s{color:#777;font-size:12px}' +
      '.mm-cart-oferta__badge{align-self:flex-start;padding:1px 7px;border-radius:999px;background:#29371C;color:#E5E1D1;font-size:11px;font-weight:600}' +
      '.mm-cart-oferta__cta{margin-top:auto;padding:7px 6px;border-radius:6px;background:#172B21;color:#E5E1D1;font-size:12px;text-align:center}' +
      '.mm-cart-oferta__flecha{position:absolute;top:34%;z-index:2;width:28px;height:28px;padding:0;display:grid;place-items:center;border-radius:50%;background:#fff;border:1px solid rgba(23,43,33,.2);box-shadow:0 1px 5px rgba(0,0,0,.15);cursor:pointer}' +
      '.mm-cart-oferta__flecha::before{content:"";width:7px;height:7px;border-right:2px solid #172B21;border-top:2px solid #172B21;transform:rotate(45deg);margin-right:2px}' +
      '.mm-cart-oferta__flecha--izq{left:-8px}.mm-cart-oferta__flecha--izq::before{transform:rotate(-135deg);margin:0 0 0 2px}' +
      '.mm-cart-oferta__flecha--der{right:-8px}.mm-cart-oferta__flecha[hidden]{display:none}' +
      '.mm-cart-oferta__ayuda{margin:8px 0 0;font-size:12px;color:#6b6b6b;text-align:center}' +
      '.mm-cart-oferta--ok{display:block;background:rgba(41,55,28,.10)}' +
      '.mm-cart-oferta--ok .mm-cart-oferta__titulo{margin:0}.mm-cart-oferta--ok .mm-cart-oferta__nota{margin:4px 0 0}' +
      '.m-cart-drawer-item:not(:has(.m-cart-item__price-discounted)) .m-cart__discount{display:none}' +
      '@media (max-width:480px){.mm-cart-oferta{margin:12px 12px 6px;padding:12px}.mm-cart-oferta__card{flex-basis:124px}.mm-cart-oferta__nombre{font-size:11px}}' +
      '.mm-oferta-aviso{margin:0 0 16px;padding:12px 14px;border-radius:10px;background:rgba(229,225,209,.6);border:1px solid rgba(23,43,33,.12);font-size:14px;line-height:1.45;color:#172B21}';
    document.head.appendChild(s);
  }

  function cargarOfertas() {
    if (ofertasCache) return Promise.resolve(ofertasCache);
    return fetch('/collections/' + COLECCION + '/products.json?limit=60', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        ofertasCache = (j.products || []).filter(function (p) { return p.variants && p.variants.length; }).map(function (p) {
          return { handle: p.handle, title: p.title, precio: aCentavos(p.variants[0].price), img: p.images && p.images[0] ? p.images[0].src : '' };
        });
        return ofertasCache;
      })
      .catch(function () { return []; });
  }

  function elegir(ofertas, cart) {
    var enCarrito = {};
    var minimo = Infinity;
    cart.items.forEach(function (it) {
      enCarrito[it.handle] = true;
      if (it.original_price < minimo) minimo = it.original_price;
    });
    var validas = ofertas.filter(function (o) { return !enCarrito[o.handle]; });
    var usadas = {}, res = [];
    validas.forEach(function (o) { var c = categoria(o.handle); if (!usadas[c] && res.length < MAX_TARJETAS) { usadas[c] = true; res.push(o); } });
    validas.forEach(function (o) { if (res.length < MAX_TARJETAS && res.indexOf(o) < 0) res.push(o); });
    // el 5% siempre cae en el arreglo de menor valor del pedido
    return res.map(function (o) {
      return { handle: o.handle, title: o.title, precio: o.precio, img: o.img, ahorro: Math.floor(Math.min(o.precio, minimo) * DESCUENTO / 100) };
    });
  }

  function soles(centavos) { return 'S/ ' + Math.round(centavos / 100); }

  function armarOfertas(ofertas) {
    var caja = document.createElement('div');
    caja.className = 'mm-cart-oferta';
    caja.setAttribute('data-mm-oferta', '');
    var t = document.createElement('p'); t.className = 'mm-cart-oferta__titulo'; t.textContent = 'Aprovecha el 5% de descuento en un segundo arreglo';
    var n = document.createElement('p'); n.className = 'mm-cart-oferta__nota'; n.textContent = 'Otro familiar o amigo también puede enviar sus condolencias: misma entrega, un solo costo de envío y una tarjeta propia para cada arreglo.';
    var lista = document.createElement('div'); lista.className = 'mm-cart-oferta__lista';
    ofertas.forEach(function (o) {
      var a = document.createElement('a');
      a.className = 'mm-cart-oferta__card';
      a.href = '/products/' + o.handle + '?desde=carrito';
      if (o.img) { var im = document.createElement('img'); im.className = 'mm-cart-oferta__img'; im.loading = 'lazy'; im.alt = o.title; im.src = o.img.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2'); a.appendChild(im); }
      var nom = document.createElement('span'); nom.className = 'mm-cart-oferta__nombre'; nom.textContent = o.title; a.appendChild(nom);
      var pr = document.createElement('span'); pr.className = 'mm-cart-oferta__precio';
      var b = document.createElement('b'); b.textContent = soles(o.precio);
      pr.appendChild(b); a.appendChild(pr);
      if (o.ahorro > 0) { var bd = document.createElement('span'); bd.className = 'mm-cart-oferta__badge'; bd.textContent = 'Ahorras S/ ' + o.ahorro; a.appendChild(bd); }
      var cta = document.createElement('span'); cta.className = 'mm-cart-oferta__cta'; cta.textContent = 'Personalizar y agregar'; a.appendChild(cta);
      lista.appendChild(a);
    });
    var carril = document.createElement('div'); carril.className = 'mm-cart-oferta__carril';
    var izq = document.createElement('button'); izq.type = 'button'; izq.className = 'mm-cart-oferta__flecha mm-cart-oferta__flecha--izq'; izq.setAttribute('aria-label', 'Ver anteriores'); izq.hidden = true;
    var der = document.createElement('button'); der.type = 'button'; der.className = 'mm-cart-oferta__flecha mm-cart-oferta__flecha--der'; der.setAttribute('aria-label', 'Ver más opciones');
    function estado() {
      izq.hidden = lista.scrollLeft < 8;
      der.hidden = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 8;
    }
    izq.addEventListener('click', function () { lista.scrollBy({ left: -lista.clientWidth * 0.8, behavior: 'smooth' }); });
    der.addEventListener('click', function () { lista.scrollBy({ left: lista.clientWidth * 0.8, behavior: 'smooth' }); });
    lista.addEventListener('scroll', estado, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(estado).observe(lista);
    carril.appendChild(lista); carril.appendChild(izq); carril.appendChild(der);
    caja.appendChild(t); caja.appendChild(n); caja.appendChild(carril);
    var ay = document.createElement('p'); ay.className = 'mm-cart-oferta__ayuda';
    ay.textContent = 'El 5% se aplica al arreglo de menor valor de tu pedido.' + (ofertas.length > 2 ? ' Desliza para ver ' + (ofertas.length - 2) + (ofertas.length === 3 ? ' opción más.' : ' opciones más.') : '');
    caja.appendChild(ay);
    setTimeout(estado, 120);
    return caja;
  }

  var listaCache = {};
  function preciosLista(handle) {
    if (!listaCache[handle]) {
      listaCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { var m = {}; if (p && p.variants) p.variants.forEach(function (v) { m[v.id] = v.compare_at_price || 0; }); return m; })
        .catch(function () { return {}; });
    }
    return listaCache[handle];
  }

  function ahorroEnOfertas(cart) {
    return Promise.all(cart.items.map(function (i) {
      return preciosLista(i.handle).then(function (m) {
        var lista = m[i.variant_id] || 0;
        return lista > i.original_price ? (lista - i.original_price) * i.quantity : 0;
      });
    })).then(function (v) { return v.reduce(function (a, b) { return a + b; }, 0); });
  }

  function armarAplicado(cart, enOfertas) {
    var caja = document.createElement('div');
    caja.className = 'mm-cart-oferta mm-cart-oferta--ok';
    caja.setAttribute('data-mm-oferta', '');
    var p = document.createElement('p'); p.className = 'mm-cart-oferta__titulo';
    if (enOfertas > 0) {
      p.textContent = '\u2713 Ahorras ' + dinero(enOfertas + cart.total_discount) + ' en tu pedido';
      var n = document.createElement('p'); n.className = 'mm-cart-oferta__nota';
      n.textContent = dinero(enOfertas) + ' en ofertas + ' + dinero(cart.total_discount) + ' por tu segundo arreglo (5%)';
      caja.appendChild(p); caja.appendChild(n);
    } else {
      p.textContent = '\u2713 Ahorras ' + dinero(cart.total_discount) + ' con el 5% de descuento en tu segundo arreglo';
      caja.appendChild(p);
    }
    var e = document.createElement('p'); e.className = 'mm-cart-oferta__nota'; e.textContent = 'Y pagas un solo costo de envío por ambos arreglos.';
    caja.appendChild(e);
    return caja;
  }

  function contenedor() { return document.querySelector('m-cart-drawer-items, [data-minimog-cart-items]'); }

  function pintar() {
    var cont = contenedor();
    if (!cont || trabajando) return;
    trabajando = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var previo = cont.querySelector('[data-mm-oferta]');
      var clave = cart.token + '|' + cart.item_count + '|' + cart.total_discount + '|' + cart.items.map(function (i) { return i.key; }).join(',');
      if (previo && clave === ultimaClave) { trabajando = false; return; }
      if (previo) previo.remove();
      ultimaClave = clave;
      if (!cart.item_count) { trabajando = false; return; }
      if (cart.item_count >= 2) {
        if (cart.total_discount > 0) {
          ahorroEnOfertas(cart).then(function (enOfertas) {
            if (!cont.querySelector('[data-mm-oferta]')) { estilos(); cont.appendChild(armarAplicado(cart, enOfertas)); }
            trabajando = false;
          });
        } else { trabajando = false; }
        return;
      }
      cargarOfertas().then(function (ofertas) {
        var elegidas = elegir(ofertas, cart);
        if (elegidas.length) { estilos(); cont.appendChild(armarOfertas(elegidas)); }
        trabajando = false;
      });
    }).catch(function () { trabajando = false; });
  }

  function programar() { clearTimeout(temporizador); temporizador = setTimeout(pintar, 250); }

  function iniciarCarrito() {
    estilos();
    var drawer = document.getElementById('MinimogCartDrawer');
    if (!drawer) return;
    new MutationObserver(programar).observe(drawer, { childList: true, subtree: true });
    programar();
  }

  /* ---------- Ficha: copia los datos del primer arreglo cuando el cliente llega desde el carrito ---------- */
  function poner(el, valor, evento) {
    if (!el) return;
    el.value = valor;
    el.dispatchEvent(new Event(evento || 'input', { bubbles: true }));
  }

  function copiarDatos() {
    if (!/[?&]desde=carrito/.test(window.location.search)) return;
    if (!document.querySelector('.custom-container')) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var linea = null;
      cart.items.forEach(function (i) { if (!linea && i.properties && i.properties['Fecha de entrega']) linea = i; });
      if (!linea) return;
      var p = linea.properties;
      var f = document.querySelector('input[name="properties[Fecha]"]');
      if (f && p['Fecha de entrega']) { if (f._flatpickr) f._flatpickr.setDate(p['Fecha de entrega'], true); else poner(f, p['Fecha de entrega'], 'change'); }
      var h = document.querySelector('select[name="properties[Horario]"]');
      if (h && p['Horario de entrega']) { for (var i = 0; i < h.options.length; i++) if (h.options[i].value === p['Horario de entrega']) { poner(h, p['Horario de entrega'], 'change'); break; } }
      var b = document.querySelector('select[name="properties[Base]"]');
      if (b && p['Base']) { for (var j = 0; j < b.options.length; j++) if (b.options[j].value === p['Base']) { poner(b, p['Base'], 'change'); break; } }
      if (p['Diseño de dedicatoria']) {
        var radios = document.querySelectorAll('input[name="properties[Dedicatoria]"]');
        for (var k = 0; k < radios.length; k++) if (radios[k].value === p['Diseño de dedicatoria']) { radios[k].checked = true; radios[k].dispatchEvent(new Event('change', { bubbles: true })); break; }
      }
      if (p['Nombre Fallecido']) {
        var chk = document.getElementById('dedicatoria-checkbox');
        if (chk && !chk.checked) { chk.checked = true; chk.dispatchEvent(new Event('change', { bubbles: true })); }
        poner(document.getElementById('nombre-fallecido'), p['Nombre Fallecido']);
      }
      estilos();
      var aviso = document.createElement('p');
      aviso.className = 'mm-oferta-aviso';
      aviso.textContent = 'Estás agregando un segundo arreglo. Copiamos la fecha, el horario, la tarjeta y el nombre del fallecido. Indica quién lo envía (por ejemplo, otro familiar) y, si deseas, escribe su mensaje. El 5% de descuento y un solo costo de envío se aplican en el carrito.';
      var caja = document.querySelector('.custom-container');
      caja.parentNode.insertBefore(aviso, caja);
    }).catch(function () {});
  }

  function iniciar() { iniciarCarrito(); setTimeout(copiarDatos, 400); }
  if (document.readyState !== 'loading') iniciar(); else document.addEventListener('DOMContentLoaded', iniciar);
})();
